import { configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'
// import sessionStorage from "redux-persist/es/storage/session";
import storage from 'redux-persist/lib/storage'

import customerViewReducer from '../features/customerViewSlice'
import addNoteReducer from '../features/addNotesSlice'
import tripFormReducer from '../features/tripFormSlice'

const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2,
}

const persistedcustomerViewReducer = persistReducer(
  persistConfig,
  customerViewReducer,
  addNoteReducer,
  tripFormReducer,
)

export const store = configureStore({
  reducer: {
    tripShow: persistedcustomerViewReducer,
    notes: addNoteReducer,
    tripForm: tripFormReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
